
export const renderThumbs = (children, isSelected) =>{return null}

export const renderIndicators = (onClickHandler, isSelected, index, label) => {
	if (isSelected){
		return <li className="carousel-indicator indicator-selected"/>
	} else {
		return <li
			onClick={onClickHandler}
			onKeyDown={onClickHandler}
			value={index}
			key={index}
			className="carousel-indicator"
		/>
	}
}
const arrowStyles = {
	position: 'absolute',
	zIndex: 2,
	
	width: 30,
	height: 30,
	cursor: 'pointer'
};

export const renderArrowPrev = (onClickHandler, hasPrev, label) => {
    return hasPrev && (
        <div className="carousel-arrow-prev" onClick={onClickHandler} title={label} style={{ ...arrowStyles, left: '-10px' }}>

        </div>
    )
}

export const renderArrowNext = (onClickHandler, hasNext, label) => {
    return hasNext && (
		<div className="carousel-arrow-next" onClick={onClickHandler} title={label} style={{ ...arrowStyles, right: '-10px' }}>

        </div>
    )
}